/* eslint-disable */
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import moment from 'moment-timezone';
import { useEffect, useRef, useState } from 'react';
import Spinner from '../../components/Spinner/Spinner';
import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import {
  ArrangeTripRequest,
  CustomerLocationOrder,
  DeliveryZoneWithLocationIds,
  RootState,
  TripArrangeStop,
  TripRequest,
  TripWithStopsDetails,
  Vehicle,
  ZoneRoutingInfo,
} from '../../store/config/types';
import { fetchCouriers } from '../../store/actions/couriers.actions';
import { formatDate } from '../../utils/string.helpers';
import { createTrip } from '../../store/actions/trips.actions';
import { couriersService } from '../../services/couriers.service';
import tripsService from '../../services/trips.service';
import { useHistory, useParams } from 'react-router-dom';
import { fetchTrips } from '../../store/actions/trips.actions';
import { DeliveryServiceProvider } from '../../store/config/types/deliveryServiceProvider.types';
import { TripOptimizingMethod } from '../../store/config/enums/trips.enum';
import TripEditView from './TripEditView';
import { Alert, CircularProgress, StepButton, Table, TableBody, TableCell, TableHead, Tooltip } from '@mui/material';
import {
  CheckOutlined,
  ChevronLeft,
  ChevronRight,
  ErrorOutline,
  PanoramaFishEye,
  Save,
  Warning,
} from '@material-ui/icons';
import TripWizardDeliverySelector from './wizard-elements/delivery-selector';
import TripWizardZoneVehicleSelector from './wizard-elements/zone-vehicle-selector';
import RoutingProgressTable from './wizard-elements/RoutingProgressTable';
import { useTargetDate } from '../../store/context/date.context';

interface TripCreationWizardParams {
  // eslint-disable-next-line
  onClose?: (date?: string) => void;
}
const mapStateToProps = (state: RootState, params: TripCreationWizardParams) => {
  return {
    couriers: state.couriers,
    trips: state.trips,
    loggedIn: state.auth.loggedIn,
    auth: state.auth,
    onclose: params.onClose,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, any>) => ({
  fetchCouriers: () => dispatch(fetchCouriers()),
  fetchTrips: (from: Date | null = null, to: Date | null = null) => dispatch(fetchTrips(from, to)),
  createTrip: (tripRequest: TripRequest) => dispatch(createTrip(tripRequest)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

function TripCreationWizard({ fetchCouriers, couriers, loggedIn, auth, onclose }: PropsFromRedux) {
  if (auth.account?.shipper?.timezone) moment.tz.setDefault(auth.account?.shipper?.timezone);

  const routingAttribs = useRef<any>({});
  const [activeStep, setActiveStep] = useState(-1);
  const { date, setDate } = useTargetDate();
  const [errorMessage, setErrorMessage] = useState<string[]>([]);
  const [deliveryServiceProviders, setDeliveryServiceProviders] = useState<DeliveryServiceProvider[]>([]);
  const [routingIsInProgress, setRoutingIsInProgress] = useState(false);
  const [arrangedTrips, setArrangedTrips] = useState<TripWithStopsDetails[] | undefined>(undefined);
  const [unAssignStops, setUnAssignStops] = useState<TripArrangeStop[]>([]);
  const [defaultOptimizingMethod, setDefaultOptimizingMethod] = useState<TripOptimizingMethod>(
    TripOptimizingMethod.NONE,
  );
  const [routingProgress, setRoutingProgress] = useState<
    {
      [key: string]: {
        status: 'PENDING' | 'CALL_ROUTER' | 'COMPLETED';
        progress: number;
        tripsCount: number;
        zone: any;
      };
    }[]
  >([]);
  const [routerResponseTripsCount, setRouterResponseTripsCount] = useState(0);
  const saveFunctionRef = useRef<() => void>();
  const [saving, setSaving] = useState(false);

  const history = useHistory();

  const fetchDeliveryServiceProviders = () => {
    setDeliveryServiceProviders([]);
    if (auth?.account?.shipper?.shipperId) {
      couriersService.fetchDeliveryServiceProviders().then((dsps) => setDeliveryServiceProviders(dsps ?? []));
    }
  };

  const handleRoutingResultReceive = async (result: {
    trips: TripWithStopsDetails[];
    defaultTripOptimizingMethod?: TripOptimizingMethod;
    startColorPaletteIndex?: number;
    errors?: string[];
  }) => {
    const data = tripsService.prepareArrangedTrips(result);

    await Promise.all(
      result.trips.map((trip) => {
        tripsService.LocationsPathService.updateTripPoints(trip);
        return tripsService.attachTotalInvoiceAndGrossProfitOfTrip(trip);
      }),
    );

    const trips = data?.trips ?? [];
    // setErrorMessage(data?.errors ?? []);
    const optimizingMethod = data?.defaultTripOptimizingMethod;
    if (optimizingMethod) setDefaultOptimizingMethod(optimizingMethod);
    const startColorPaletteIndex = data?.startColorPaletteIndex ?? 0;
    // initial optimization
    if (trips && trips.length > 0) {
      // tripsService.optimizeTrips(trips, true, TripOptimizingMethod.NONE, false, true).then((trips) => {
      let hasError = false;
      // trips.forEach((trip, tripIndex) => {
      //   trips[tripIndex].additionalData = {
      //     ...trips[tripIndex].additionalData,
      //     colorPaletteIndex: startColorPaletteIndex + tripIndex,
      //   };
      //   if (trip.status === 'optimizationError') {
      //     hasError = true;
      //   } else {
      //     trip.tripStops.forEach((stop, stopIndex) => {
      //       const customer = routingAttribs?.current?.deliveryOrdersOfDate.find(
      //         (d: CustomerLocationOrder) => d.customerId == stop.placeInfo?.placeId,
      //       )?.customer;
      //       stop.label = tripsService.makeStopLabel(tripIndex, stopIndex);
      //       if (!stop.location.customer) stop.location.customer = customer;
      //     });
      //   }
      // });
      if (hasError) {
        setRoutingIsInProgress(false);
      } else {
        const unAssignedStops = trips.filter((trip) => trip.tripId === -1);
        setUnAssignStops(unAssignedStops.length > 0 ? unAssignedStops[0].tripStops : []);
        setArrangedTrips(
          JSON.parse(
            JSON.stringify(
              trips
                ?.filter((trip) => trip.tripId !== -1)
                .sort((t1, t2) => {
                  const compare = (t1.additionalData?.zoneCaption ?? '')
                    .toLowerCase()
                    .localeCompare((t2.additionalData?.zoneCaption ?? '').toLowerCase());
                  if (compare === 0) {
                    if (t1.startsAt && t2.startsAt) {
                      return new Date(t1.startsAt).valueOf() - new Date(t2.startsAt).valueOf();
                    }
                  }
                  return compare;
                }),
            ),
          ),
        );
        setRouterResponseTripsCount(trips?.filter((trip) => trip.tripId !== -1).length);
        setRoutingIsInProgress(false);
        if (errorMessage.length == 0) {
          setActiveStep(3);
        }
      }
      // });
    } else {
      setRoutingIsInProgress(false);
    }
  };

  const handleStreamDataReceive = (data: any) => {
    console.log(data);
    switch (data.type) {
      case 'START':
        const zones: any[] = routingAttribs?.current?.zones ?? [];
        if (data.zones?.length) {
          const rProg: any = {};
          data.zones.forEach((deliveryZoneId: number) => {
            const zone: any = zones.find((z) => z.deliveryZoneId == deliveryZoneId);
            rProg[deliveryZoneId] = { status: 'PENDING', progress: 0, tripsCount: 0, zone };
          });
          setRoutingProgress(rProg);
        }
        break;
      case 'STATUS':
      case 'PROGRESS':
        setRoutingProgress((rProg) => {
          rProg[data.deliveryZoneId].status = data.status;
          rProg[data.deliveryZoneId].progress = data.progress ?? 0;
          rProg[data.deliveryZoneId].tripsCount = data.tripsCount ?? 0;
          return { ...rProg };
        });
        break;
      case 'ERROR':
        setErrorMessage((errMsg) => [...errMsg, data.message]);
        break;
      case 'RESULT':
        handleRoutingResultReceive(data.result);
        break;
    }
  };
  const handleStreamError = (error: any) => {};

  const fetchTripArranges = async () => {
    setRoutingProgress([]);
    const errors: string[] = [];
    const attrs = routingAttribs?.current ?? {};
    const zonesInfoForRoute = { ...attrs.zonesInfo };
    let everythingOk =
      attrs.pickupTimewindow[0].trim() != '' &&
      attrs.tripDate?.trim() != '' &&
      moment(`${attrs.tripDate} ${attrs.pickupTimewindow[0]}`).isSameOrBefore(
        `${attrs.tripDate} ${attrs.pickupTimewindow[1]}`,
      );
    if (!everythingOk) {
      errors.push('Please set trip date and pickup timewindow.');
    }
    attrs?.selectedDeliveryOrders?.forEach((deliveryOrderIndex: number) => {
      const deliveryOrder: CustomerLocationOrder = attrs?.deliveryOrdersOfDate[deliveryOrderIndex];
      if (deliveryOrder) {
        deliveryOrder.packageGroups.forEach((packageGroup) => {
          zonesInfoForRoute[deliveryOrder.additionalData?.zoneId ?? 0].packageGroupIds.push(
            packageGroup.packageGroupId ?? 0,
          );
        });
      }
    });
    const interestedZones = Object.values(zonesInfoForRoute).filter((z: any) => z.packageGroupIds?.length);

    if (!interestedZones.length) {
      errors.push('Please select at least one order.');
      everythingOk = false;
    }

    if (!interestedZones.every((z: any) => z.vehicleIds?.length)) {
      errors.push('Please select at least one vehicle for each zone.');
      everythingOk = false;
    }

    if (everythingOk) {
      //const fixedTripDate = moment(tripDate, 'YYYY-MM-DD') < moment() ? moment().format('YYYY-MM-DD') : tripDate;
      const arrangedTripsReq: ArrangeTripRequest[] = [];
      interestedZones.forEach((zoneInfo: any) => {
        arrangedTripsReq.push({
          vehiclesInfo: zoneInfo.vehicleIds.map((vehicleId: number) => ({
            vehicleId,
            courierId: attrs.vehicles?.find((v: Vehicle) => v.vehicleId === vehicleId)?.courierId,
          })),
          packageGroupIds: zoneInfo.packageGroupIds,
          startsAt: `${attrs.tripDate} ${attrs.pickupTimewindow[0]}`,
          pickupTo: `${attrs.tripDate} ${attrs.pickupTimewindow[1]}`,
          isRoundTrip: zoneInfo.isRoundTrip ?? true,
          deliveryZoneId: zoneInfo.deliveryZoneId ?? undefined,
        });
      });
      tripsService.arrangeTripStream(arrangedTripsReq, handleStreamDataReceive, handleStreamError);
    } else {
      setErrorMessage(errors);
    }
  };
  const handleCancel = () => {
    afterSave();
  };

  const handleEditCancel = () => {
    setArrangedTrips(undefined);
    setActiveStep(1);
  };
  const afterSave = () => {
    // setDeliveryOrdersOfDate([]);
    setSaving(false);
    if (onclose) {
      onclose(date);
    }
    history.goBack();
  };
  const onSaveStart = () => {
    setSaving(true);
  };

  useEffect(() => {
    fetchDeliveryServiceProviders();
  }, []);

  useEffect(() => {
    if (!couriers.loadingCouriers && !couriers.couriers && !couriers.couriersErrorMessage) {
      fetchCouriers();
    }
  }, [fetchCouriers, couriers.couriersErrorMessage, couriers.loadingCouriers, loggedIn]);

  useEffect(() => {
    if (couriers.couriers?.length && routingAttribs) {
      routingAttribs.current.couriers = couriers.couriers;
    }
  }, [couriers.couriers, routingAttribs]);

  useEffect(() => {
    if (routingAttribs?.current) {
      routingAttribs.current.zones = [{ caption: '', locationIds: [], deliveryZoneId: 0 }];
      setActiveStep(0);
    }
  }, [routingAttribs]);

  useEffect(() => {
    if (activeStep < 2) {
      setRouterResponseTripsCount(0);
    }
    if (activeStep === 2 && !routerResponseTripsCount) {
      makeTripsToReview();
    }
  }, [activeStep]);
  useEffect(() => {
    console.log(routerResponseTripsCount + ' Trips');
  }, [routerResponseTripsCount]);

  console.log('refreh wizard');

  const checkRoutingAttrs = () => {
    const result: { [key: number]: { caption: string; errors: string[]; tasks: string[]; done: string[] } } = {};
    const attrs: any = routingAttribs?.current;
    if (!attrs) return result;
    const selectedOrdersIds: number[] = attrs.selectedDeliveryOrders ?? [];
    const selectedOrders = ((attrs.deliveryOrdersOfDate ?? []) as CustomerLocationOrder[]).filter((_, index) =>
      selectedOrdersIds.includes(index),
    );
    const zonesInfo: { [key: number]: ZoneRoutingInfo } = attrs.zonesInfo ?? {};
    const zones: DeliveryZoneWithLocationIds[] = attrs.zones ?? [];

    result[0] = {
      caption: 'Delivery orders',
      errors: [],
      done: [],
      tasks: ['Set trip date and pickup timewindow', 'Select orders'],
    };
    if (!selectedOrdersIds.length) {
      result[0].errors.push('No order selected.');
    } else {
      result[0].done.push(`${selectedOrdersIds.length} order${selectedOrdersIds.length > 1 ? 's' : ''} selected`);
    }

    result[1] = { caption: 'Vehicle options', errors: [], done: [], tasks: ['Select active vehicles of each zone'] };
    const noVehicleZones: string[] = [];
    Object.values(zonesInfo).forEach((z) => {
      const zone = zones.find((zItem) => zItem.deliveryZoneId === z.deliveryZoneId);
      if (selectedOrders.some((o) => o.additionalData?.zoneId == zone?.deliveryZoneId)) {
        if (!zonesInfo[zone?.deliveryZoneId ?? 0].vehicleIds?.length) {
          noVehicleZones.push(`"${zone?.caption ?? ''}"`);
        }
      }
    });
    if (noVehicleZones.length) {
      result[1].errors.push(`Active at least 1 vehicle for ${noVehicleZones.join(', ')}.`);
    } else {
      result[1].done.push(`Vehicle setup is ok.`);
    }

    result[2] = { caption: 'Routing', errors: [], done: [], tasks: ['Routing'] };
    result[2].errors = [...errorMessage];
    if (routerResponseTripsCount)
      result[2].done = [`${routerResponseTripsCount} trip${routerResponseTripsCount > 1 ? 's' : ''} created.`];

    result[3] = { caption: 'Edit', errors: [], done: [], tasks: ['Edit trips'] };

    return result;
  };

  const makeTripsToReview = async () => {
    setRouterResponseTripsCount(0);
    setErrorMessage([]);
    setRoutingIsInProgress(true);

    fetchTripArranges();
  };

  if (!couriers.couriersFetched) {
    return <Spinner />;
  }

  const pickupTimewindowToString = () => {
    if (!routingAttribs?.current?.pickupTimewindow) return '';
    return (
      moment(routingAttribs.current.pickupTimewindow[0], 'HH:mm').format('h:mm a') +
      ' to ' +
      moment(routingAttribs.current.pickupTimewindow[1], 'HH:mm').format('h:mm a')
    );
  };

  const handleNavigationClick = (type: string) => {
    if (type == 'back') {
      if (activeStep > 0) setActiveStep((step) => step - 1);
    } else {
      if (activeStep < 3) {
        setActiveStep((step) => step + 1);
      } else {
        if (saveFunctionRef?.current) saveFunctionRef.current();
      }
    }
  };

  const stepsMessages = checkRoutingAttrs();

  return (
    <div className="trips-dnd-full-page" style={{ overflow: 'hidden' }}>
      <Grid container className="trips-dnd" flexDirection="column">
        <Grid item className="trips-dnd-title-area">
          <Grid container>
            <Grid item flexGrow={1} alignContent="center">
              <Typography variant="subtitle1">Trip Wizard ({formatDate(date)})</Typography>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Grid>
        <Grid item flexGrow={1} style={{ position: 'relative' }}>
          <Grid
            container
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              overflow: 'hidden',
            }}
          >
            {activeStep == 0 ? (
              <TripWizardDeliverySelector tripDate={date} routingAttributes={routingAttribs} />
            ) : activeStep == 1 ? (
              <TripWizardZoneVehicleSelector routingAttributes={routingAttribs} />
            ) : activeStep == 2 ? (
              <Grid container flexDirection="column">
                <Grid item p={1}>
                  <Typography variant="h4">Summary</Typography>
                </Grid>
                <Grid item p={1}>
                  <Typography variant="subtitle1">
                    Date: {moment(routingAttribs?.current?.tripDate).format('MMM DD,YYYY')}
                  </Typography>
                  <Typography variant="subtitle1">Pickup timewindow: {pickupTimewindowToString()}</Typography>
                </Grid>
                {Object.values(stepsMessages).map((step, sIndex) => {
                  if (sIndex > 2) return <></>;
                  return (
                    <Grid item p={1} key={`step-${sIndex}`}>
                      <Typography variant="subtitle1">{step.caption}</Typography>
                      {!routingIsInProgress &&
                        step.errors.map((errMessage, eIndex) => (
                          <Alert
                            variant="standard"
                            color="error"
                            key={`error${sIndex}-${eIndex}`}
                            icon={<Warning fontSize="inherit" />}
                          >
                            {errMessage}
                          </Alert>
                        ))}
                      {step.done.map((taskMessage, tIndex) => (
                        <Alert variant="standard" color="success" key={`task${sIndex}-${tIndex}`}>
                          {taskMessage}
                        </Alert>
                      ))}
                    </Grid>
                  );
                })}
                {routingIsInProgress && (
                  <Grid item flexGrow={1} position="relative">
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'scroll' }}>
                      <RoutingProgressTable routingProgress={routingProgress} />
                    </div>
                  </Grid>
                )}
              </Grid>
            ) : activeStep == 3 ? (
              <TripEditView
                attributedDate={moment(date, 'YYYY-MM-DD').toDate()}
                availableCourierIds={[]}
                couriers={couriers?.couriers ?? []}
                vehicles={routingAttribs?.current?.vehicles}
                customers={routingAttribs?.current?.customers}
                date={date}
                deliveryServiceProviders={deliveryServiceProviders}
                timezone={auth?.account?.timezone}
                trips={arrangedTrips ?? []}
                unassigned={unAssignStops ?? []}
                warehouses={routingAttribs?.current?.warehouses}
                onCancel={handleEditCancel}
                onAfterSave={afterSave}
                defaultOptimizingMethod={defaultOptimizingMethod}
                onStartSaving={onSaveStart}
                allTripsIsNew={true}
                withoutTitleBar
                saveFunctionRef={saveFunctionRef}
                ignoreTimeWindowWarning
              />
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            alignItems="center"
            p={1}
            style={{ backgroundColor: '#eee' }}
            flexWrap="nowrap"
            overflow="hidden"
          >
            <Grid item flexGrow={1}>
              <Grid container alignItems="center" gap={1} flexWrap="nowrap">
                <Grid item>
                  <Button onClick={() => handleCancel()} color="error" variant="contained">
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Stepper activeStep={activeStep} nonLinear>
                    {Object.values(stepsMessages).map((step, sIndex) => {
                      return (
                        <Step
                          completed={activeStep > sIndex}
                          key={`step-${sIndex}`}
                          onClick={sIndex < 3 ? () => setActiveStep(sIndex) : undefined}
                        >
                          <Tooltip
                            title={
                              <Grid container flexDirection="column" alignItems="start">
                                {activeStep <= sIndex ? (
                                  stepsMessages[sIndex]?.tasks.map((msg: string, msgIndex: number) => (
                                    <Typography color="silver" key={`step${sIndex}-task${msgIndex}`} fontSize={14}>
                                      <PanoramaFishEye style={{ height: 16 }} />
                                      <span>{msg}</span>
                                    </Typography>
                                  ))
                                ) : (
                                  <>
                                    {stepsMessages[sIndex]?.done.map((msg: string, msgIndex: number) => (
                                      <Typography color="lightgreen" key={`step${sIndex}-msg${msgIndex}`} fontSize={14}>
                                        <CheckOutlined style={{ height: 16 }} />
                                        <span>{msg}</span>
                                      </Typography>
                                    ))}
                                    {stepsMessages[sIndex]?.errors.map((msg: string, msgIndex: number) => (
                                      <Typography color="orange" key={`step${sIndex}-err${msgIndex}`} fontSize={14}>
                                        <ErrorOutline style={{ height: 16 }} />
                                        {msg}
                                      </Typography>
                                    ))}
                                  </>
                                )}
                              </Grid>
                            }
                            arrow
                          >
                            <StepButton>
                              <StepLabel error={stepsMessages[sIndex]?.errors.length > 0 && activeStep > sIndex}>
                                {step.caption}
                              </StepLabel>
                            </StepButton>
                          </Tooltip>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container gap={1} flexWrap="nowrap">
                <Button disabled={activeStep <= 0} onClick={() => handleNavigationClick('back')}>
                  <ChevronLeft />
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => handleNavigationClick('next')}
                  disabled={
                    activeStep < 0 || activeStep > 3 || (activeStep == 2 && routerResponseTripsCount == 0) || saving
                  }
                >
                  {activeStep === 3 ? (
                    <>Save {saving ? <CircularProgress size={14} /> : <Save />}</>
                  ) : (
                    <>
                      Next <ChevronRight />
                    </>
                  )}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default connector(TripCreationWizard);
